/*
 * Put-category.ts
 * Description: Includes the declaration
 * of the function for updating a category
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Category} from '@/ts/categories/validate-category';

/**
 * Updating category data
 *
 * @return {Object} Promise - updated category data
 * @param {String} slug - id of a restaurant
 * @param {Category} data - category data
 * @param {Number} categoryId - id of a the category
 */
export function putCategory(data: Category, slug: string, categoryId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/menu-categories/' + categoryId,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

// Creating an interface for the values
interface Item {
    id: number;
}

/**
 * Updating category order
 *
 * @return {Object} Promise - updated category order
 * @param {String} slug - id of a restaurant
 * @param {Item[]} values - order of categories
 */
export function putCategoryOrder(values: Item[], slug: string) {
    const jwt = localStorage.getItem('jwt');
    const menuIDs = [];
    for (const item of values) {
        if (item.hasOwnProperty('id')) {
            menuIDs.push(item.id);
        }
    }
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/menu-categories',
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                menu_ids: menuIDs,
            },
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
